<template>
  <div class="data-list">
    <!-- 面包屑 -->
    <Hreadcrumb :hreadcrumbAry="hreadcrumbAry" />
    <div class="page-top">
      <div class="title">数据分析</div>
      <div class="tabs">
        <div class="left">
          <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane key="1" tab="监测"></a-tab-pane>
          <a-tab-pane key="2" tab="监护"></a-tab-pane>
        </a-tabs>
        </div>
        <div class="right">
          <div class="list">
            <div class="item">
              <div>
                <div class="text">数据告警</div>
                <div class="num">{{sum}}</div>
              </div>
            </div>
            <div class="item">
              <div class="line"></div>
              <div>
                <div class="text">已核实数据</div>
                <div class="num">{{getverify}}</div>
              </div>
            </div>
            <div class="item">
              <div class="line"></div>
              <div>
                <div class="text">告警项目</div>
                <div class="num">{{parNum}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-content">
      <div class="list-box">
        <div class="title-box">
          <div class="left">数据列表</div>
          <div class="right">
            <div class="input-box">
              <a-input v-model="warning" placeholder="请按照项目名称搜索" @change="onChange">
                <a-icon slot="suffix" type="search" allowClear/>
              </a-input>
            </div>
          </div>
        </div>
        <div class="table">
          <a-table :columns="columns" :data-source="listData" :pagination="pagination" @change="pageChange">
            <template slot="operation" slot-scope="text, record">
              <a-button type="link" style="padding:0;" @click="toDetail(record)">查看详情</a-button>
            </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Hreadcrumb from "@/components/Hreadcrumb";
import { Pie } from "@antv/g2plot";
import { getTop, getWarringInfo } from "@/request/newApi"
export default {
  props: {},
  data() {
    return {
      active: 1,
      sum: undefined, // 数据告警数
      getverify: undefined, // 已核实
      parNum: undefined, // 告警项目数
      procode: undefined, // 项目编号
      warning: "", // 项目名称
      local: undefined, // 地址
      sumNumber: undefined, // 告警数
      verifyNumber: undefined, //已确认
      // Type: 1,
      pagination: {
        // 分页参数
        current: 1, //当前页
        total: 0, //总条数
        pageSize: 10, //每页多少条
        showQuickJumper: true, //显示跳转到第N页的输入框
        showSizeChanger:true,
        showTotal:(total, range) => `共${total}条记录`,
      },
      hreadcrumbAry: [
        { name: "数据看板", path: "/", query: {} },
        { name: "数据", path: "/", query: {} },
      ],
      columns: [
        {
          title: "序号", //标题
          dataIndex: "key",
          width:80,
        },
        {
          title: "项目编号", //标题
          ellipsis: true, //出现省略号
          dataIndex: "proCode",
          width: 100,
        },
        {
          title: "名称",
          ellipsis: true, //出现省略号
          dataIndex: "proName",
        },
        {
          title: "地址",
          ellipsis: true, //出现省略号
          dataIndex: "local",
        },
        {
          title: "告警数",
          dataIndex: "sumNumber",
          ellipsis: true,
        },
        {
          title: "已确认",
          dataIndex: "verifyNumber",
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "address",
          ellipsis: true,
          scopedSlots: { customRender: "operation" },
        },
      ],
      listData: [],
    };
  },
  components: {
    Hreadcrumb,
  },
  created() {
    this.getTop();
    this.getWarringInfo();
  },
  mounted() {},
  methods: {
    // 数据告警
    async getTop(){
      let { data } = await getTop({
        monitorType: this.active
      });
      console.log(data)
      if(data.code === 200 ){
        // console.log('111')
        this.sum = data.result.sum;
        this.getverify = data.result.getverify;
        this.parNum = data.result.parNum;
      }
    },
    // 数据列表
    async getWarringInfo() {
      this.tableLoading = true;
      let { data } = await getWarringInfo({
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        proName:this.warning,
        monitorType: this.active
      });
      // console.log(data)
      if (data.code === 200) {
        this.pagination.total = data.result.total;
        this.listData = data.result.list;
        this.listData.forEach((item, index) => {
          item.key = this.$listNum(this.pagination.current,index); //table组件要用 唯一标识
        });
      }
    
      this.tableLoading = false;
    },
    toDetail(item) {
      console.log(item);
      this.$router.push({path:'/project_errorList',query:{cid:item.proId}})
    },
    // 筛选
    onChange(pageNumber) {
      console.log("Page: ", pageNumber);
      this.pagination.current = 1;
      this.getWarringInfo();
    },
    // 翻页
    pageChange(pageObj) {
      console.log("Page: ", pageObj);
      this.pagination = pageObj;
      this.getWarringInfo();
    },
    callback(key) {
      console.log(key);
      this.active = key;
      this.getTop();
      this.getWarringInfo();
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/base.less";
.page-top {
  background: #fff;
  .title {
    font-size: 16px;
    font-weight: bold;
    padding: 10px 24px 20px;
  }
  .tabs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 24px;
    .left{
      align-self: flex-end;
    }
    .right {
      .list {
        display: flex;
        justify-content: center;
        padding-right:20px;
        padding-bottom:10px;
        .item {
          display: flex;
          align-items: center;
          text-align: center;
          .line {
            width: 1px;
            height: 30px;
            background: #eee;
            margin: 0 25px;
          }
          .text {
            color: @c4;
          }
          .num {
            font-size: 20px;
            font-weight: bold;
            margin-top: 5px;
            color: @c3;
          }
        }
      }
    }
  }
}
.page-content {
  padding: @pad @pad 100px;
  .list-box {
    background: #fff;
    .title-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 24px;
    }
    .table {
      .pagination {
        display: flex;
        justify-content: flex-end;
        padding: 30px 20px;
      }
    }
  }
}
</style>
<style >
</style>